"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatToISO = exports.formatDateTimeFromISO = exports.formatDateFromISONoUTC = exports.formatDateFromISO = exports.formatWithMonth = exports.formatNumber = exports.formatCurrency = void 0;

var _CurrencyUtils = _interopRequireDefault(require("./CurrencyUtils"));

var _NumberUtils = _interopRequireDefault(require("./NumberUtils"));

var _DateUtils = _interopRequireDefault(require("./DateUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default-member */
// CURRENCY FORMATTING

/**
 * @deprecated please use CurrenyUtils
 */
var formatCurrency = function formatCurrency(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$0,0.00';
  return _CurrencyUtils.default.formatCurrency(value, format);
}; // NUMBER FORMATTING

/**
 * @deprecated please use NumberUtils
 */


exports.formatCurrency = formatCurrency;

var formatNumber = function formatNumber(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0,00';
  return _NumberUtils.default.formatNumber(value, format);
};
/**
 * @deprecated please use NumberUtils
 */


exports.formatNumber = formatNumber;

var formatWithMonth = function formatWithMonth(value) {
  return _NumberUtils.default.formatWithMonth(value);
}; // DATE FORMATTING

/**
 * @deprecated please use DateUtils
 */


exports.formatWithMonth = formatWithMonth;

var formatDateFromISO = function formatDateFromISO(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  return _DateUtils.default.formatDateFromISO(value, format);
};
/**
 * @deprecated please use DateUtils
 */


exports.formatDateFromISO = formatDateFromISO;

var formatDateFromISONoUTC = function formatDateFromISONoUTC(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  return _DateUtils.default.formatDateFromISONoUTC(value, format);
};
/**
 * @deprecated please use DateUtils
 */


exports.formatDateFromISONoUTC = formatDateFromISONoUTC;

var formatDateTimeFromISO = function formatDateTimeFromISO(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY hh:mm';
  return _DateUtils.default.formatDateTimeFromISO(value, format);
};
/**
 * @deprecated please use DateUtils
 */


exports.formatDateTimeFromISO = formatDateTimeFromISO;

var formatToISO = function formatToISO(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  return _DateUtils.default.formatToISO(value, format);
};

exports.formatToISO = formatToISO;
//# sourceMappingURL=FormattingUtils.js.map